import { FC } from 'react';
import { cn } from '@/utils';

export type UserButtonSkeletonProps = {
  desktopBreakpoint?: 'lg' | 'xl';
  className?: string;
};

const pulseClassName = 'animate-pulse bg-default-200';

const UserButtonSkeleton: FC<UserButtonSkeletonProps> = ({
  desktopBreakpoint = 'lg',
  className,
}) => {
  const isXlBreakpoint = desktopBreakpoint === 'xl';

  return (
    <div
      aria-hidden
      className={cn(
        'inline-flex items-center gap-2 rounded-xl p-1',
        isXlBreakpoint ? 'xl:w-[200px] xl:p-2' : 'lg:w-[200px] lg:p-2',
        className,
      )}
    >
      <div
        className={cn(
          'h-7 w-7 shrink-0 rounded-full',
          pulseClassName,
          isXlBreakpoint ? 'xl:h-9 xl:w-9' : 'lg:h-9 lg:w-9',
        )}
      />
      <div
        className={cn(
          'hidden min-w-0 flex-1 flex-col gap-1.5',
          isXlBreakpoint ? 'xl:flex' : 'lg:flex',
        )}
      >
        <div className={cn('h-3.5 w-full rounded-md', pulseClassName)} />
        <div className={cn('h-3 w-[90%] rounded-md', pulseClassName)} />
      </div>
    </div>
  );
};

export default UserButtonSkeleton;
